// extracted by mini-css-extract-plugin
module.exports = {"sectionFive":"GetStartedSection_sectionFive__BeKmB"};